module.exports = __webpack_public_path__ + "img/dogs.10e85b82.svg";